import { render } from "./ClassMetricTableCellStatusComponent.vue?vue&type=template&id=a8c5a3a0&ts=true"
import script from "./ClassMetricTableCellStatusComponent.vue?vue&type=script&lang=ts"
export * from "./ClassMetricTableCellStatusComponent.vue?vue&type=script&lang=ts"

import exportComponent from "/workspace/src/services/admin/webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__